import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./integration_instance_type.js";
//#region src/integration_instance_type_helper.ts
var integration_instance_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(instanceType) {
	switch (instanceType) {
		case 1: return "Sandbox";
		case 2: return "Prod";
	}
}
//#endregion
export { integration_instance_type_helper_exports, name };

//# sourceMappingURL=integration_instance_type_helper.js.map